import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

import { Service } from '../../../../core/models/service.type';
import { ServiceCard } from '../service-card/service-card.component';

@Component({
  selector: 'app-services-section',
  imports: [MatIconModule, ServiceCard, TranslateModule],
  templateUrl: './services-section.component.html',
  styleUrl: './services-section.component.scss',
})
export class ServicesSection {
  readonly services: Service[] = [
    {
      title: 'services.items.freight_forwarding.title',
      description:
        'services.items.freight_forwarding.description',
      icon: 'public',
      image: 'https://images.unsplash.com/photo-1578575437130-527eed3abbec?q=80&w=2070',
    },
    {
      title: 'services.items.heavy_cargo.title',
      description: 'services.items.heavy_cargo.description',
      icon: 'construction',
      image: 'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?q=80&w=2070',
    },
    {
      title: 'services.items.duty_exemption.title',
      description:
        'services.items.duty_exemption.description',
      icon: 'percent',
      image: 'https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?q=80&w=2070',
    },
    {
      title: 'services.items.relocation.title',
      description: 'services.items.relocation.description',
      icon: 'swap_horiz',
      image: 'https://images.unsplash.com/photo-1600585152220-90363fe7e115?q=80&w=2070',
    },
  ];
}
